import { render, staticRenderFns } from "./RamsActionPanel.vue?vue&type=template&id=2fca6e17&"
import script from "./RamsActionPanel.vue?vue&type=script&lang=js&"
export * from "./RamsActionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports